



















































import { Component, Vue } from 'vue-property-decorator';
import DocumentTile from '@/components/documents/DocumentTile.vue';
import { IDocumentTileModel } from '@/models/common';
import API from '@/Api';

@Component({
    components: {
        DocumentTile,
    },
})
export default class Policies extends Vue {
    public HrAccess: any = null;
    public dressCodePolicy: IDocumentTileModel = {
        title: 'Dress Code',
        subTitle: 'Policy',
        link: 'Sulekha_Dress_Code.pdf',
        img: 'Sulekha_Dress_Code.jpg',
    };

    public insurance: IDocumentTileModel = {
        title: 'Insurance',
        subTitle: 'Policy',
        link: 'Sulekha.com-Employee-Benefits-Manual-Revised-FY2023.pdf',
        img: 'Insurance_Document.JPG',
    };

    

    public codeOfConduct: IDocumentTileModel = {
        title: 'Code of Conduct - 2020',
        subTitle: 'Policy',
        link: 'Sulekha_COC_Code_of_Conduct_2020.pdf',
        img: 'Sulekha_Code_Of_Conduct.jpg',
    };

    public vendorAgreement: IDocumentTileModel = {
        title: 'Vendor Agreement',
        subTitle: 'Policy',
        link: 'Sulekha_Vendor_Agreement.pdf',
        img: 'Sulekha_Vendor_Agreement.jpg',
    };

    public recruitment: IDocumentTileModel = {
        title: 'Recruitment',
        subTitle: 'Policy',
        link: 'Sulekha_Recruitment.pdf',
        img: 'Sulekha_Recruitment.jpg',
    };

    public leavePolicy: IDocumentTileModel = {
        title: 'Leave',
        subTitle: 'Policy',
        link: 'Sulekha_Leave_Policy.pdf',
        img: 'Sulekha_Leave_Policy.jpg',
    };

    public itPolicy: IDocumentTileModel = {
        title: 'InfoSec',
        subTitle: 'Policy',
        link: 'ITPolicy-Sulekha.pdf',
        img: 'Sulekha_Information_Security_Policy.jpg',
    };
    public travelPolicy: IDocumentTileModel = {
        title: 'Travel Policy',
        subTitle: 'Policy',
        link: 'Sulekha_Travel_Policy.pdf',
        img: 'Sulekha_Travel_Policy.jpg',
    };
    public payrollCalendar: IDocumentTileModel = {
        title: 'Payroll Calendar',
        subTitle: 'Policy',
        link: 'Payroll_Calendar.pdf',
        img: 'payroll_calendar.jpg',
    };
    public laptopPolicy: IDocumentTileModel = {
        title: 'Laptop Policy',
        subTitle: 'Policy',
        link: 'Laptop_reimbursement_policy.pdf',
        img: 'laptop.jpg',
    };
     public sexPolicy: IDocumentTileModel = {
        title: 'POSH policy',
        subTitle: 'Policy',
        link: 'Sulekha_POSH_Policy.pdf',
        img: 'POSH_image.png',
    };

    public poshtrainig: IDocumentTileModel = {
        title: 'POSH Training',
        subTitle: 'Training material ',
        link: 'POSH_Training_material.pdf',
        img: 'POSH_image.png',
    };

    public created() {
        API.Instance
        .get('api/policy-access')
        .then((response) => {
            this.HrAccess = response.data;
        });
    }
}
